import { Config } from './config.interface';

export const localConfig: Config = {
  privyAppId: 'clvl1vs8c024vv6y0vh0zgf3p',
};
